<h2>Total Frames in Cart: ({{ frames.length }})</h2>
<div *ngFor="let frame of frames; let i = index">
  <!-- Frame image -->
  <div class="col s12 m12 l3">
    <img src="{{ frame.largeImageUrl }}" />
  </div>
  <!-- Frame details -->
  <div class="col s12 m12 l9">
    <div class="details-scope">
      <div class="details-content">
        <ul class="details-list">
          <li>
            <p><strong>Brand:</strong> {{ frame.brandName }}</p>
          </li>
          <li>
            <p><strong>Frame:</strong> {{ frame.styleName }} ({{ frame.upc }})</p>
          </li>
          <li>
            <p><strong>Color:</strong> {{ frame.colorDescription }}</p>
          </li>
          <li>
            <p><strong>Size:</strong> {{ frame.eyeSize }}</p>
          </li>
          <!--            <li class="js-item-details-view">-->
          <!--              <p class="pointer js-btn-item-view enterClick" role="button" tabindex="0" aria-expanded="false">-->
          <!--                <strong>Lens:</strong>-->
          <!--                Progressive <mat-icon class="" [svgIcon]="displayPrescription ? 'icon-up-arrow' : 'icon-down-arrow'" (click)="togglePrescription()"></mat-icon>-->
          <!--                <span class="price-d price-symbol ">$108                            </span>-->
          <!--              </p>-->

          <!--              <div [ngClass]="displayPrescription ? 'view-content' : 'hide-content'">-->
          <!--                <div class="item-prescription" style="display: block;">-->
          <!--                  <table width="100%" cellpadding="0" cellspacing="0">-->
          <!--                    <tbody>-->
          <!--                    <tr>-->
          <!--                      <td unptreplaced="TH"></td>-->
          <!--                      <th>SPH</th>-->
          <!--                      <th>CYL</th>-->
          <!--                      <th>Axis</th>-->
          <!--                      <th>ADD</th>-->
          <!--                      <th>PD</th>-->
          <!--                    </tr>-->
          <!--                    <tr>-->
          <!--                      <th>OD</th>-->
          <!--                      <td class="od_sph">-0.50</td>-->
          <!--                      <td class="od_cyl">-0.25</td>-->
          <!--                      <td class="od_axis">30</td>-->
          <!--                      <td class="od_add">0.75</td>-->
          <!--                      <td class="pd" rowspan="2">63</td>-->
          <!--                    </tr>-->
          <!--                    <tr>-->
          <!--                      <th>OS</th>-->
          <!--                      <td class="os_sph">-0.50</td>-->
          <!--                      <td class="os_cyl">-0.25</td>-->
          <!--                      <td class="os_axis">30</td>-->
          <!--                      <td class="os_add">0.75</td>-->
          <!--                    </tr>-->
          <!--                    </tbody>-->
          <!--                  </table>-->
          <!--                </div>-->
          <!--                <dl class="lenses-list">-->
          <!--                  <dd class="lenses">-->
          <!--                    <p>-->
          <!--                      Progressive<span class="price-d price-symbol">$49</span>-->
          <!--                    </p>-->
          <!--                  </dd>-->
          <!--                  <dd class="lenses">-->
          <!--                    <p>-->
          <!--                      Clear<span class="price-d price-symbol"></span>-->
          <!--                    </p>-->
          <!--                  </dd>-->
          <!--                  <dd class="lenses">-->
          <!--                    <p>-->
          <!--                      Advanced Lenses<span class="price-d price-symbol">$59</span>-->
          <!--                    </p>-->
          <!--                  </dd>-->
          <!--                  <dd class="lenses">-->
          <!--                    <p>-->
          <!--                      - 1.6 hi-index (Thinner 25%)<span class="price-d price-symbol"></span>-->
          <!--                    </p>-->
          <!--                  </dd>-->
          <!--                  <dd class="lenses">-->
          <!--                    <p>-->
          <!--                      - Blue light filter<span class="price-d price-symbol"></span>-->
          <!--                    </p>-->
          <!--                  </dd>-->
          <!--                  <dd class="lenses">-->
          <!--                    <p>-->
          <!--                      - UV protection<span class="price-d price-symbol"></span>-->
          <!--                    </p>-->
          <!--                  </dd>-->
          <!--                </dl>-->
          <!--              </div>-->
          <!--            </li>-->
          <li class="js-item-details-view js-case-item">
            <div class="js-case-box"></div>
          </li>
        </ul>
        <hr class="divider" />
        <div class="btn-group mt-30">
          <button class="btn btn-outline" (click)="removeFrame(i)">Remove Frame</button>
        </div>
      </div>
    </div>
  </div>
</div>
